module.exports = __webpack_public_path__ + "static/media/bowl-veggies600.dddc4d81.jpeg";